var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 46.5,
    cy: 46.5,
    r: 44.5,
    fill: "black",
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3333 57.9233L57.9233 46L39.3333 34.0767V57.9233ZM46.0108 76C41.8625 76 37.9622 75.2128 34.31 73.6383C30.6583 72.0639 27.4817 69.9272 24.78 67.2283C22.0783 64.5294 19.9397 61.3556 18.3642 57.7067C16.7881 54.0583 16 50.1597 16 46.0108C16 41.8625 16.7872 37.9622 18.3617 34.31C19.9361 30.6583 22.0728 27.4817 24.7717 24.78C27.4706 22.0783 30.6444 19.9397 34.2933 18.3642C37.9417 16.7881 41.8403 16 45.9892 16C50.1375 16 54.0378 16.7872 57.69 18.3617C61.3417 19.9361 64.5183 22.0728 67.22 24.7717C69.9217 27.4706 72.0603 30.6444 73.6358 34.2933C75.2119 37.9417 76 41.8403 76 45.9892C76 50.1375 75.2128 54.0378 73.6383 57.69C72.0639 61.3417 69.9272 64.5183 67.2283 67.22C64.5294 69.9217 61.3556 72.0603 57.7067 73.6358C54.0583 75.2119 50.1597 76 46.0108 76ZM46 72.6667C53.4444 72.6667 59.75 70.0833 64.9167 64.9167C70.0833 59.75 72.6667 53.4444 72.6667 46C72.6667 38.5556 70.0833 32.25 64.9167 27.0833C59.75 21.9167 53.4444 19.3333 46 19.3333C38.5556 19.3333 32.25 21.9167 27.0833 27.0833C21.9167 32.25 19.3333 38.5556 19.3333 46C19.3333 53.4444 21.9167 59.75 27.0833 64.9167C32.25 70.0833 38.5556 72.6667 46 72.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play_button.3864ab6f29e048e61a33bc7741cb3f4f.svg";
export { ForwardRef as ReactComponent };